export default function (initialTimezone: string) {
  return {
    namespaced: true,
    state: {
      timezone: initialTimezone,
    },
  };
}